'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCfAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.05176e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 -6.94394e-06 20C-6.94394e-06 13.3333 0.000144993 6.66667 -3.05176e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-6.94394e-06 5.33333H28V0H-3.05176e-05L-6.94394e-06 5.33333Z",
          fill: "#083D96"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-6.94394e-06 14.6667H28V9.33333H-6.94394e-06V14.6667Z",
          fill: "#37AE39"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-6.94394e-06 20H28V14.6667H-6.94394e-06V20Z",
          fill: "#FFD13F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6667 20H17.3333V0H10.6667V20Z",
          fill: "#E42346"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66666 3.44667L3.49109 4.2847L3.92484 2.9077L2.76455 2.04863L4.20819 2.03563L4.66666 0.666667L5.12513 2.03563L6.56877 2.04863L5.40848 2.9077L5.84223 4.2847L4.66666 3.44667Z",
          fill: "#FFD03B"
        }
      )
    ]
  }
);
const VpFlagCfAsset = forwardRef(FlagCfAsset);

export { VpFlagCfAsset as default };
